<template>
<div class="SignIn padding-20 bgc box-shadow">
    <keep-alive include="SignInList">
        <router-view></router-view>
    </keep-alive>
</div>
</template>

<script>
export default {
    name: 'SignIn',
    data() {
        return {}
    },
    mounted() {},
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss">
.SignIn {
    min-width: 1100px;
    font-family: PingFangSC-Regular,PingFang SC;
}
</style>